import { API } from "../../../cache";

export async function listDueDateChanges(entityType, entityId) {
  const res = await fetch(
    `${API}/due-date-changes?entity_type=${encodeURIComponent(entityType)}&entity_id=${encodeURIComponent(entityId)}`,
    { credentials: "include" }
  );
  if (!res.ok) throw new Error("Failed to load due date history");
  return res.json();
}
